import gql from 'graphql-tag'

export const DELETE =  gql`
mutation(
    $reuseId: ID!
    $type: String!
  )
  {
    deleteReuse (
      reuseId: $reuseId
      type: $type
    )
  }
`

